module.exports = __webpack_public_path__ + "img/floor_OG6.0b0838e9.svg";